import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Text } from "@/shared/ui";
import { usePinnedAssistants } from "../hooks/useAssistants";
import { AssistantIcon } from "./AssistantIcon";

/**
 * The sidebar's pinned-assistants section — compact rows linking to each
 * assistant's detail. Composed into the shell in `app` (cross-feature), and
 * renders nothing until the user has pinned something, so the rail stays clean.
 */
export function PinnedAssistants() {
  const { t } = useTranslation();
  const { data } = usePinnedAssistants();

  if (!data || data.length === 0) return null;

  return (
    <div className="mt-5 flex flex-col gap-0.5">
      <Text variant="label" as="div" className="px-3 pb-1">
        {t("assistants.pinned.title")}
      </Text>
      {data.map((assistant) => (
        <Link
          key={assistant.id}
          to="/assistants/$id"
          params={{ id: assistant.id }}
          className="grid h-9 grid-cols-[24px_1fr] items-center gap-2 rounded-md px-2.5 font-sans text-[13.5px] font-medium text-ink outline-none transition-colors duration-150 ease-house hover:bg-line-soft hover:text-ink focus-visible:bg-line-soft data-[status=active]:bg-ink data-[status=active]:text-paper"
        >
          <AssistantIcon
            name={assistant.name}
            iconUrl={assistant.icon_url}
            size="sm"
            className="size-6 rounded-md text-[11px]"
          />
          <span className="truncate">{assistant.name}</span>
        </Link>
      ))}
    </div>
  );
}
